<template>
  <v-app>
    <!-- Global Header - AppNavbar already contains v-app-bar with app prop -->
    <AppNavbar @open-filters="openFiltersFromNavbar" />
    
    <v-main>
      <router-view @show-login-popup="handleShowLoginPopup" />
    </v-main>

    <!-- Global Footer -->
    <AppFooter />
    
    <!-- Login Popup -->
    <div v-if="showLoginPopup" class="login-popup-overlay">
      <LoginPopup @close="showLoginPopup = false" @login-success="handleLoginSuccess" />
    </div>
  </v-app>
</template>

<script>
import AppNavbar from "./components/AppNavbar.vue";
import AppFooter from "./components/AppFooter.vue";
import LoginPopup from "./components/LoginPopup.vue";

export default {
  name: "App",
  components: {
    AppNavbar,
    AppFooter,
    LoginPopup,
  },
  data() {
    return {
      showLoginPopup: false,
      selectedCabData: null,
      routerData: null
    };
  },
  methods: {
    openFiltersFromNavbar() {
      // This will notify the active page that filters should open
      this.$emit("open-filters");
    },
    
    handleShowLoginPopup(data) {
      // Store the selected cab data and router data
      this.selectedCabData = data.cab;
      this.routerData = data.routerData;
      
      // Show the login popup
      this.showLoginPopup = true;
    },
    
    async handleLoginSuccess(userData) {
      console.log('data' , userData)
      // Close the login popup
      this.showLoginPopup = false;
      
      // If we have stored cab data, navigate to confirm booking
      if (this.selectedCabData && this.routerData && userData != null) {
        // Get the logged in user ID
        const userId = userData.id;
        
        const formData = {
          tnc: 1,
          referenceId: this.routerData.referenceId,
          tripType: this.routerData.tripType,
          cabType: this.selectedCabData?.cab?.id?.toString(),
          advanceReceived: "0",
          totalAmount: this.selectedCabData.fare.totalAmount,
          sendEmail: 1,
          sendSms: 1,
          startDate: this.selectedCabData.pickUpDate,
          startTime: this.selectedCabData.pickUpTime,
          sourceAddress: this.routerData.sourceAddress,
          sourceName: this.routerData.sourceAddress,
          sourceLat: this.routerData.sourceLat,
          sourceLong: this.routerData.sourceLong,
          destinationAddress: this.routerData.destinationAddress,
          destinationName: this.routerData.destinationAddress,
          destinationLat: this.routerData.destinationLat,
          destinationLong: this.routerData.destinationLong,
          image: this.selectedCabData.cab.image,
          firstName: userData.first_name,
          lastName: userData.first_name,
          primaryContactCode: 91,
          primaryContactNumber: userData.phone,
          email: userData.email,
          aggregator_id: this.selectedCabData.aggregator_id.toString(),
          aggregator_name: this.selectedCabData.aggregator_name,
          rating: this.selectedCabData.AndroidRating,
          company_id: 1,
          user_id: userId, // Use the logged in user ID
          vehicle_type: this.selectedCabData.cab.cabType,
        };
        
        console.log('formData after login', formData);
        
        const queryString = encodeURIComponent(JSON.stringify(formData));
        
        this.$router.push({
          name: "ConfirmBooking",
          query: {
            data: queryString
          },
        });
        
        // Clear the stored data
        this.selectedCabData = null;
        this.routerData = null;
      }
    }
  },
};
</script>

<style>
html, body {
  overflow-x: hidden;
  width: 100%;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}

main {
  padding-top: 70px; /* Account for fixed navbar height */
  min-height: calc(100vh - 120px); /* adjust based on header/footer height */
  overflow-x: hidden;
  width: 100%;
}

.login-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}
</style>
